/**
 * Interactive Product Card 2511 - JavaScript
 * 完整的变体选择、库存管理和加购功能
 */
(function () {
  "use strict";

  class InteractiveProductCard {
    constructor(form) {
      this.form = form;
      this.container = form.querySelector(".product-card-content");
      if (!this.container) return;

      this.productId = this.container.dataset.productId;
      this.productHandle = this.container.dataset.productHandle;
      this.getFormattedMoney = window.getFormattedMoney;
      // Variant picker elements
      this.variantPicker = form.querySelector(".variant-picker-simple-2511");
      this.variantIdInput = form.querySelector("[data-variant-id-input]");
      this.discountCodeInput = form.querySelector('input[name="discountCode"]');

      // Option elements
      this.colorSwatches = form.querySelectorAll(".button-color-swatch");
      this.sizeOptionWrap = form.querySelector(".simple-variant-option.size-option");
      this.colorPosition = form.querySelector(".simple-variant-option.color-option")?.dataset.optionPosition || "1";
      this.sizePosition = this.sizeOptionWrap?.dataset.sizePosition || "2";
      this.unknownSizeValue = this.sizeOptionWrap?.dataset.unknownSize || "I don't know my size";
      this.sizeUnknownBtn = form.querySelector(".size-btn-unknown");
      this.sizeKnowBtn = form.querySelector(".size-btn-know-trigger");
      this.sizeKnowOverlayBtn = form.querySelector(".size-btn-know-overlay");
      this.sizeDropdown = form.querySelector(".size-dropdown");
      this.sizeDropdownOverlay = form.querySelector(".size-dropdown-overlay");
      this.sizeOptions = form.querySelector(".size-options");
      this.sizeOptionBtns = form.querySelectorAll(".size-option-btn");

      // Display elements
      this.productImage = form.querySelector("[data-product-image-wrapper] img");
      this.priceWrapper = form.querySelector("[data-price-wrapper]");
      this.currentPriceEl = form.querySelector("[data-current-price]");
      this.originalProductPriceEl = form.querySelector(".original-product-price");
      this.specialProductPriceEl = form.querySelector(".special-product-price");
      this.discountBadge = form.querySelector("[data-discount-badge]");
      this.discountValue = form.querySelector("[data-discount-value]");
      this.stockStatus = form.querySelector("[data-stock-status]");
      this.sizeBtnText = form.querySelector(".size-btn-text");
      this.sizeBtnTextOverlay = form.querySelector(".size-btn-text-overlay");

      // Action buttons
      this.addToCartBtn = form.querySelector("[data-add-to-cart]");
      this.learnMoreBtn = form.querySelector(".btn-learn-more");

      // Variant data
      this.variants = this.loadVariantData();
      this.currentVariant = null;

      // Selected options
      this.selectedOptions = {};

      this.init();
    }

    getDiscountSettings() {
      const normalize = (value) => (value || "").trim().toLowerCase();
      const discountPercent = Number(this.priceWrapper?.dataset.discountPercent || 0);
      const discountCode = (this.priceWrapper?.dataset.discountCode || "").trim();
      const specialDiscountPercent = Number(this.priceWrapper?.dataset.specialDiscountPercent || 0);
      const specialDiscountCode = (this.priceWrapper?.dataset.specialDiscountCode || "").trim();
      const specialColor = (this.priceWrapper?.dataset.specialColor || "").split(/[,|]/).map(normalize).filter(Boolean);
      const selectedColor = normalize((this.selectedOptions && this.selectedOptions[this.colorPosition]) || "");
      const isSpecialColor = specialColor.length > 0 && selectedColor && specialColor.includes(selectedColor);
      const specialActive = isSpecialColor && specialDiscountPercent > 0;
      const manualComparePrice = Number(this.priceWrapper?.dataset.manualComparePrice || 0);
      const active = discountPercent > 0;
      return {
        discountPercent,
        discountCode,
        active,
        specialDiscountPercent,
        specialDiscountCode,
        specialActive,
        isSpecialColor,
        selectedColor,
        specialColor,
        manualComparePrice,
      };
    }

    syncColorRadio(activeSwatch) {
      this.colorSwatches.forEach((swatch) => {
        const radio = swatch.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = swatch === activeSwatch;
        }
      });
    }

    setActive(el, active) {
      if (!el) return;
      el.classList.toggle("active", active);
      el.classList.toggle("is-active", active);
    }

    removeActive(el) {
      if (!el) return;
      el.classList.remove("active", "is-active");
    }

    init() {
      if (!this.variants || this.variants.length === 0) {
        console.warn("No variant data found for product:", this.productId);
        return;
      }

      this.initializeDefaultSelections();
      this.bindEvents();
      this.updateDisplay();
    }

    loadVariantData() {
      const dataScript = this.form.querySelector("[data-variant-data]");
      if (!dataScript) return [];

      try {
        const data = JSON.parse(dataScript.textContent);
        return data.variants || [];
      } catch (e) {
        console.error("Error parsing variant data:", e);
        return [];
      }
    }

    getVariantOptionValue(variant, position) {
      if (!variant || !position) return null;
      return variant[`option${position}`] ?? null;
    }

    isUnknownSizeValue(value) {
      if (!value) return false;
      const normalized = String(value).trim().toLowerCase();
      return (
        normalized.includes("don't know") ||
        normalized.includes("dont know") ||
        normalized.includes("不知道") ||
        normalized.includes("sizing kit")
      );
    }

    getUnknownSizeValue() {
      if (this.unknownSizeValue) return this.unknownSizeValue;

      for (const variant of this.variants) {
        for (const position of [this.colorPosition, this.sizePosition, "3"]) {
          const value = this.getVariantOptionValue(variant, position);
          if (this.isUnknownSizeValue(value)) return value;
        }
      }

      return "I don't know my size";
    }

    initializeDefaultSelections() {
      if (this.colorSwatches.length > 0) {
        const colorInput = this.form.querySelector(`[data-option-input="${this.colorPosition}"]`);
        const selectedValue = colorInput?.value;
        const activeSwatch =
          Array.from(this.colorSwatches).find((swatch) => swatch.dataset.optionValue === selectedValue) ||
          this.form.querySelector(".button-color-swatch.active") ||
          this.colorSwatches[0];

        this.colorSwatches.forEach((swatch) => this.removeActive(swatch));
        this.setActive(activeSwatch, true);
        this.selectedOptions[this.colorPosition] = activeSwatch.dataset.optionValue;
        this.syncColorRadio(activeSwatch);

        if (colorInput) {
          colorInput.value = activeSwatch.dataset.optionValue;
        }
      }

      if (this.sizeUnknownBtn) {
        const unknownSize = this.getUnknownSizeValue();
        this.selectedOptions[this.sizePosition] = unknownSize;
        const sizeInput = this.form.querySelector(`[data-option-input="${this.sizePosition}"]`);
        if (sizeInput) {
          sizeInput.value = unknownSize;
        }
      }

      this.updateSizeAvailability();
      this.findCurrentVariant();
    }

    bindEvents() {
      // 颜色选择
      this.colorSwatches.forEach((swatch) => {
        swatch.addEventListener("click", (e) => this.handleColorSelection(e));
      });

      // 尺寸选择按钮
      if (this.sizeUnknownBtn) {
        this.sizeUnknownBtn.addEventListener("click", () => this.handleSizeUnknown());
      }

      if (this.sizeKnowBtn) {
        this.sizeKnowBtn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleSizeOptions();
        });
      }

      if (this.sizeKnowOverlayBtn) {
        this.sizeKnowOverlayBtn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleSizeOptions();
        });
      }

      // 具体尺寸选项按钮
      this.sizeOptionBtns.forEach((btn) => {
        if (!btn.disabled) {
          btn.addEventListener("click", (e) => this.handleSizeSelection(e));
        }
      });

      // 表单提交（加购）由 ProductForm 处理
      // this.form.addEventListener("submit", (e) => this.handleAddToCart(e));

      // Learn More 按钮
      if (this.learnMoreBtn) {
        this.learnMoreBtn.addEventListener("click", () => this.handleLearnMore());
      }
    }
    closeSizeOptions() {
      if (this.sizeOptions) {
        this.sizeOptions.style.display = "none";
        this.sizeOptions.classList.remove("show");
      }
      if (this.sizeDropdownOverlay) {
        this.sizeDropdownOverlay.style.display = "none";
        this.sizeDropdownOverlay.style.width = "";
        this.sizeDropdownOverlay.style.right = "";
      }
      this.sizeDropdown?.classList.remove("is-open");
      this.sizeKnowBtn?.classList.remove("expanded");
      this.sizeKnowBtn?.setAttribute("aria-expanded", "false");
      this.sizeKnowOverlayBtn?.classList.remove("expanded", "active");
      this.sizeKnowOverlayBtn?.setAttribute("aria-expanded", "false");
    }

    lockDropdownWidth() {
      if (!this.sizeKnowBtn || !this.sizeDropdownOverlay) return;
      const width = this.sizeKnowBtn.getBoundingClientRect().width;
      this.sizeDropdownOverlay.style.width = `${width}px`;
      this.sizeDropdownOverlay.style.right = "auto";
    }
    handleColorSelection(e) {
      const swatch = e.currentTarget;
      const color = swatch.dataset.optionValue;
      const position = swatch.dataset.optionPosition;

      this.colorSwatches.forEach((s) => this.removeActive(s));
      this.setActive(swatch, true);
      this.syncColorRadio(swatch);

      this.selectedOptions[position] = color;

      const input = this.form.querySelector(`[data-option-input="${position}"]`);
      if (input) {
        input.value = color;
      }

      this.updateSizeAvailability();
      this.findCurrentVariant();
      this.updateDisplay();
    }

    handleSizeUnknown() {
      this.setActive(this.sizeUnknownBtn, true);
      this.removeActive(this.sizeKnowBtn);
      this.sizeKnowBtn?.classList.remove("expanded");
      this.sizeKnowOverlayBtn?.classList.remove("expanded", "active");

      this.closeSizeOptions();

      this.sizeOptionBtns.forEach((btn) => this.removeActive(btn));

      this.selectedOptions[this.sizePosition] = this.getUnknownSizeValue();
      const input = this.form.querySelector(`[data-option-input="${this.sizePosition}"]`);
      if (input) {
        input.value = this.getUnknownSizeValue();
        if (this.sizeBtnText) {
          this.sizeBtnText.textContent = this.sizeBtnText.dataset.placeholder;
        }
        if (this.sizeBtnTextOverlay) {
          this.sizeBtnTextOverlay.textContent = this.sizeBtnTextOverlay.dataset.placeholder;
        }
      }

      this.findCurrentVariant();
      this.updateDisplay();
    }

    toggleSizeOptions() {
      const isExpanded =
        this.sizeDropdownOverlay &&
        this.sizeDropdownOverlay.style.display !== "none" &&
        this.sizeDropdownOverlay.style.display !== "";

      if (isExpanded) {
        this.removeActive(this.sizeKnowBtn);
        this.sizeKnowOverlayBtn?.classList.remove("expanded", "active");
        this.closeSizeOptions();

        const activeSizeBtn = Array.from(this.sizeOptionBtns).find((btn) => btn.classList.contains("active"));
        if (activeSizeBtn) {
          const size = activeSizeBtn.dataset.optionValue;
          if (this.sizeBtnText) {
            const clickText = this.sizeBtnText.dataset.clickText || "Size: {size}";
            this.sizeBtnText.textContent = clickText.replace("{size}", size);
          }
          this.setActive(this.sizeKnowBtn, true);
        } else {
          this.handleSizeUnknown();
        }
      } else {
        this.setActive(this.sizeKnowBtn, true);
        this.sizeKnowBtn?.classList.add("expanded");
        this.sizeKnowOverlayBtn?.classList.add("expanded", "active");
        this.removeActive(this.sizeUnknownBtn);

        const openPlaceholder =
          this.sizeBtnTextOverlay?.dataset.placeholder || this.sizeBtnText?.dataset.placeholder || "Select Your Size";

        if (this.sizeBtnText) {
          this.sizeBtnText.textContent = openPlaceholder;
        }
        if (this.sizeBtnTextOverlay) {
          this.sizeBtnTextOverlay.textContent = openPlaceholder;
        }

        if (this.sizeOptions && this.sizeDropdownOverlay) {
          // this.lockDropdownWidth();
          this.sizeDropdown?.classList.add("is-open");
          this.sizeKnowBtn?.setAttribute("aria-expanded", "true");
          this.sizeKnowOverlayBtn?.setAttribute("aria-expanded", "true");
          this.sizeOptions.classList.add("show");
          this.sizeDropdownOverlay.style.display = "block";
          this.sizeOptions.style.display = "block";
        }
      }
    }

    handleSizeSelection(e) {
      const btn = e.currentTarget;

      if (btn.disabled) return;

      const size = btn.dataset.optionValue;
      const position = btn.dataset.optionPosition;

      // 更新UI
      this.sizeOptionBtns.forEach((b) => this.removeActive(b));
      this.setActive(btn, true);

      this.setActive(this.sizeKnowBtn, true);
      this.sizeKnowOverlayBtn?.classList.add("active");
      this.removeActive(this.sizeUnknownBtn);

      // 更新选择
      this.selectedOptions[position] = size;

      // 更新隐藏输入
      const input = this.form.querySelector(`[data-option-input="${position}"]`);
      if (input) {
        input.value = size;
      }
      if (this.sizeBtnText) {
        const clickText = this.sizeBtnText.dataset.clickText || "Size: {size}";
        this.sizeBtnText.textContent = clickText.replace("{size}", size);
      }
      if (this.sizeBtnTextOverlay) {
        const clickText = this.sizeBtnTextOverlay.dataset.clickText || "Size: {size}";
        this.sizeBtnTextOverlay.textContent = clickText.replace("{size}", size);
      }
      this.closeSizeOptions();
      // 查找并更新当前变体
      this.findCurrentVariant();
      this.updateDisplay();
    }

    updateSizeAvailability() {
      const selectedColor = this.selectedOptions[this.colorPosition];
      if (!selectedColor) return;

      this.sizeOptionBtns.forEach((btn) => {
        const size = btn.dataset.optionValue;
        const variant = this.variants.find(
          (v) =>
            this.getVariantOptionValue(v, this.colorPosition) === selectedColor &&
            this.getVariantOptionValue(v, this.sizePosition) === size,
        );

        if (variant && variant.available) {
          btn.disabled = false;
          btn.classList.remove("disabled");
        } else {
          btn.disabled = true;
          btn.classList.add("disabled");

          if (btn.classList.contains("active")) {
            this.removeActive(btn);
            this.handleSizeUnknown();
          }
        }
      });
    }

    findCurrentVariant() {
      const option1 = this.selectedOptions[this.colorPosition];
      const option2 = this.selectedOptions[this.sizePosition];

      this.currentVariant =
        this.variants.find((variant) => {
          const match1 = !option1 || this.getVariantOptionValue(variant, this.colorPosition) === option1;
          const match2 = !option2 || this.getVariantOptionValue(variant, this.sizePosition) === option2;
          return match1 && match2;
        }) || null;

      if (this.currentVariant && this.variantIdInput) {
        this.variantIdInput.value = this.currentVariant.id;
      }

      return this.currentVariant;
    }

    updateProductImage() {
      if (!this.productImage || !this.currentVariant) return;

      const selectedColor = this.getVariantOptionValue(this.currentVariant, this.colorPosition);
      let imageUrl = this.currentVariant.featured_image;

      if (!imageUrl && selectedColor) {
        const fallbackVariant = this.variants.find(
          (variant) =>
            this.getVariantOptionValue(variant, this.colorPosition) === selectedColor && variant.featured_image,
        );
        imageUrl = fallbackVariant?.featured_image || null;
      }

      if (imageUrl) {
        this.productImage.src = imageUrl;
        this.productImage.srcset = imageUrl;
      }
    }

    updateDisplay() {
      if (this.currentVariant) {
        this.updateProductImage();
        this.updatePrice();
        this.updateDiscountBadge();
      }

      this.updateStockStatus();
      this.updateAddToCartButton();
    }

    updatePrice() {
      if (!this.currentVariant) return;

      const normalize = (value) => (value || "").trim().toLowerCase();
      const {
        discountPercent,
        discountCode,
        active,
        specialDiscountPercent,
        specialDiscountCode,
        specialActive,
        isSpecialColor,
        specialColor,
        manualComparePrice,
      } = this.getDiscountSettings();
      const basePrice = this.currentVariant.price;
      const basePriceFormatted = this.getFormattedMoney(basePrice, false);
      const useSpecialDiscount = isSpecialColor; // 特殊颜色优先用特殊折扣
      const appliedDiscountPercent = useSpecialDiscount ? specialDiscountPercent : discountPercent;
      const appliedDiscountCode = useSpecialDiscount ? specialDiscountCode : discountCode;

      if (this.currentPriceEl) {
        if (appliedDiscountPercent > 0) {
          const discountMultiplier = Math.max(0, (100 - appliedDiscountPercent) / 100);
          const discountedPrice = Math.round(basePrice * discountMultiplier);
          this.currentPriceEl.textContent = this.getFormattedMoney(discountedPrice);
        } else {
          this.currentPriceEl.textContent = basePriceFormatted;
        }
      }

      if (appliedDiscountPercent > 0 && this.originalProductPriceEl) {
        const comparePrice = manualComparePrice > 0 ? manualComparePrice : this.currentVariant.compare_at_price;
        const displayOriginalPrice =
          comparePrice && comparePrice > basePrice
            ? this.getFormattedMoney(comparePrice, false)
            : basePriceFormatted;
        this.originalProductPriceEl.textContent = displayOriginalPrice;
        this.originalProductPriceEl.style.display = "";
      } else if (this.originalProductPriceEl && this.currentVariant.compare_at_price > this.currentVariant.price) {
        this.originalProductPriceEl.textContent = this.getFormattedMoney(this.currentVariant.compare_at_price, false);
        this.originalProductPriceEl.style.display = "";
      } else if (this.originalProductPriceEl) {
        this.originalProductPriceEl.textContent = "";
        this.originalProductPriceEl.style.display = "none";
      }

      if (this.discountCodeInput) {
        this.discountCodeInput.value = appliedDiscountCode || "";
      }

      if (this.specialProductPriceEl) {
        this.specialProductPriceEl.classList.remove("price_hidden");
      }
      if (this.originalProductPriceEl) {
        this.originalProductPriceEl.classList.remove("price_hidden");
      }

      if (this.priceWrapper) {
        if (
          specialColor &&
          specialColor.includes(normalize(this.getVariantOptionValue(this.currentVariant, this.colorPosition)))
        ) {
          this.originalProductPriceEl?.classList.add("price_hidden");
        } else {
          this.specialProductPriceEl?.classList.add("price_hidden");
        }
      }
    }

    updateDiscountBadge() {
      if (!this.currentVariant || !this.discountBadge) return;

      if (this.currentVariant.compare_at_price > this.currentVariant.price) {
        const discount = Math.round(
          ((this.currentVariant.compare_at_price - this.currentVariant.price) / this.currentVariant.compare_at_price) *
            100,
        );

        if (this.discountValue) {
          this.discountValue.textContent = discount + "%";
        }
        this.discountBadge.style.display = "";
      } else {
        this.discountBadge.style.display = "none";
      }
    }

    isCurrentVariantAvailable() {
      return Boolean(this.currentVariant?.available);
    }

    getBuyButtonTextEl() {
      if (!this.addToCartBtn) return null;
      const contentRoot =
        this.addToCartBtn.getAttribute("is") === "custom-button"
          ? this.addToCartBtn.firstElementChild || this.addToCartBtn
          : this.addToCartBtn;
      return contentRoot.querySelector(".btn-text");
    }

    updateStockStatus() {
      if (!this.stockStatus) return;

      if (!this.isCurrentVariantAvailable()) {
        const stockText = this.stockStatus.querySelector(".stock-text");
        if (stockText) {
          stockText.textContent = 'Sold out';
        }
        this.stockStatus.style.display = "block";
      } else {
        this.stockStatus.style.display = "none";
      }
    }

    updateAddToCartButton() {
      if (!this.addToCartBtn) return;

      const contentRoot =
        this.addToCartBtn.getAttribute("is") === "custom-button"
          ? this.addToCartBtn.firstElementChild || this.addToCartBtn
          : this.addToCartBtn;
      const isAvailable = this.isCurrentVariantAvailable();
      const showText = this.addToCartBtn.dataset.buttonShowText || "";
      const soldOutText =
        this.addToCartBtn.dataset.soldOutText || window.themeVariables?.strings?.soldOutButton || "Sold Out";
      const labelText = isAvailable ? showText : soldOutText;
      const cartIcon = this.addToCartBtn.querySelector(
        ".pcs__cart-icon, .pcsh__cart-icon, .pcs-de__cart-icon, .pcsh-de__cart-icon, .psd__cart-icon",
      );

      this.addToCartBtn.disabled = !isAvailable;
      this.addToCartBtn.classList.toggle("disabled", !isAvailable);
      this.addToCartBtn.setAttribute("aria-disabled", isAvailable ? "false" : "true");

      contentRoot
        .querySelectorAll(".btn-text, .psd__cta-title, .pcsh__cta-title, .pcsh-de__cta-title")
        .forEach((el) => {
          el.textContent = labelText;
        });

      const btnText = this.getBuyButtonTextEl();
      if (
        btnText &&
        (this.addToCartBtn.classList.contains("pcs__cta") || this.addToCartBtn.classList.contains("pcs-de__cta"))
      ) {
        btnText.classList.toggle("visually-hidden", !this.addToCartBtn.classList.contains("disabled"));
      }

      if (cartIcon) {
        cartIcon.hidden = !isAvailable;
      }
    }

    setLoadingState(isLoading) {
      if (!this.addToCartBtn) return;

      const btnText = this.getBuyButtonTextEl();
      const btnLoading = this.addToCartBtn.querySelector(".btn-loading");
      const visibleTextEls = this.addToCartBtn.querySelectorAll(".pcsh__cta-text, .pcsh-de__cta-text");

      if (isLoading) {
        this.addToCartBtn.disabled = true;
        if (btnText) btnText.style.display = "none";
        visibleTextEls.forEach((el) => {
          el.style.display = "none";
        });
        if (btnLoading) btnLoading.style.display = "";
      } else {
        if (btnText) btnText.style.display = "";
        visibleTextEls.forEach((el) => {
          el.style.display = "";
        });
        if (btnLoading) btnLoading.style.display = "none";
        this.updateAddToCartButton();
      }
    }

    triggerCartUpdate() {
      // 触发主题的购物车更新事件
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        }),
      );

      // 兼容其他可能的购物车事件
      window.dispatchEvent(new CustomEvent("cart:updated"));
    }

    showSuccessMessage() {
      // 你可以自定义成功提示的方式
      // 这里简单使用 alert，实际项目中可以用更好的 toast 提示
      const message = 'Added to your cart!';

      // 如果主题有自己的通知系统，使用主题的通知
      if (window.theme && window.theme.showNotification) {
        window.theme.showNotification(message, "success");
      } else {
        // console.log(message);
        // 或者触发一个自定义事件供主题监听
        document.dispatchEvent(
          new CustomEvent("product:added-to-cart", {
            detail: { variant: this.currentVariant },
          }),
        );
      }
    }

    showErrorMessage() {
      const message =
        'Translation missing: en.product.general.add_to_cart_error';

      if (window.theme && window.theme.showNotification) {
        window.theme.showNotification(message, "error");
      } else {
        alert(message);
      }
    }

    handleLearnMore() {
      const productUrl = this.learnMoreBtn.dataset.productUrl;
      if (productUrl) {
        window.location.href = productUrl;
      }
    }

    formatMoney(cents) {
      // 简单的价格格式化，你可以根据需要调整
      const money = (cents / 100).toFixed(2);
      return "".replace("", money).replace("", money);
    }
  }

  // 初始化所有产品卡片（同一 form 只初始化一次，避免重复绑定导致下拉框闪开即关）
  function initInteractiveProductCards() {
    document.querySelectorAll(".product-form-2511:not([data-ipc-2606-init])").forEach((form) => {
      if (!form.querySelector(".product-card-content")) return;

      form.setAttribute("data-ipc-2606-init", "true");
      new InteractiveProductCard(form);
    });
  }

  function shouldInitSection(sectionRoot) {
    return (
      sectionRoot &&
      (sectionRoot.querySelector(".interactive-product-card-section") ||
        sectionRoot.querySelector(".product-card-single-section") ||
        sectionRoot.querySelector(".product-card-single-de-section") ||
        sectionRoot.querySelector(".product-card-double-section"))
    );
  }

  if (!window.__interactiveProductCard2606Bootstrapped) {
    window.__interactiveProductCard2606Bootstrapped = true;

    // Shopify 主题编辑器支持
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener("shopify:section:load", function (event) {
        if (shouldInitSection(event.target)) {
          initInteractiveProductCards();
        }
      });

      document.addEventListener("shopify:section:reorder", function (event) {
        if (shouldInitSection(event.target)) {
          initInteractiveProductCards();
        }
      });
    }

    // 页面加载时初始化
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initInteractiveProductCards);
    } else {
      initInteractiveProductCards();
    }
  } else {
    initInteractiveProductCards();
  }
})();
